import type { Entry } from '../types';

export const generateID = (sysId: string, record: Record<string, number>) => {
    const isCloned = !!record[sysId];
    record[sysId] = (record[sysId] || 0) + 1;
    return isCloned ? `${sysId}-${record[sysId]}` : sysId;
};

export function createUniqueIDs<T extends Entry>(
    entries: T[],
    ids?: Record<string, number>
) {
    const seenIDs: Record<string, number> = ids || {};

    return entries.map(entry => {
        if (entry.sys && entry.fields) {
            entry.fields.sysId = generateID(entry.sys.id, seenIDs);
        }
        return entry;
    });
}

export default createUniqueIDs;
